<template>
	<div class="main">
		<HomeView/>
		<header id="main">
			<div class="title">праздники, чтобы #боржомить</div>
			<div
				class="subline"
			>Узнай множество способов как #боржомить при любой погоде. И не забудь выбрать самую классную активность, чтобы любимый блогер проверил ее для тебя!</div>
		</header>

		<div class="filters-mobile">
			<div class="filter" @click="selectFilter('all')" :class="{selected: filter === 'all'}">ВСЕ</div>
			<div class="filter" @click="selectFilter('in')" :class="{selected: filter === 'in'}">
				<img src="@/assets/filter-in-selected.png" v-if="filter === 'in'">
				<img src="@/assets/filter-in.png" v-else>
			</div>
			<div class="filter" @click="selectFilter('out')" :class="{selected: filter === 'out'}">
				<img src="@/assets/filter-out-selected.png" v-if="filter === 'out'">
				<img src="@/assets/filter-out.png" v-else>
			</div>
		</div>

		<div class="cards">
			<uiCard v-for="card in firstCards" :key="card.id" :id="card.id" :reverse="filter === 'out'"/>
		</div>

		<uiVote/>

		<div class="cards">
			<uiCard v-for="card in secondCards" :key="card.id" :id="card.id"/>
		</div>
		<footer :style="{height: footerHeight}">
			<div class="wrap">
				<div class="title">«Боржоми», чтобы #боржомить</div>
				<div
					class="text"
				>«Боржоми» – вода, которую знают и любят миллионы людей во всем мире. Каждая капля этой воды – бесценна: «Боржоми» зарождается в недрах Грузии, проходит много километров до земной поверхности, на пути обогащаясь уникальными минералами и силой вулкана. А все для того, чтобы вместе с «Боржоми» вы могли наслаждаться праздниками, получать удовольствие от общения и быть полным энергии в любое время года.</div>
				<a
					href="https://www.borjomi.com/ru/borjoming/?utm_source=afisha&utm_medium=special_project&utm_content=landing&utm_campaign=RU-2018-12-borjomi-power-of-volcano"
					class="button"
					target="_blank"
				>Хочу праздника!</a>
			</div>
		</footer>
		<div class="sideblock" :class="{visible: showFilter}">
			<div class="filters">
				<div class="filter" @click="selectFilter('all')" :class="{selected: filter === 'all'}">ВСЕ</div>
				<div class="filter" @click="selectFilter('in')" :class="{selected: filter === 'in'}">
					<img src="@/assets/filter-in-selected.png" v-if="filter === 'in'">
					<img src="@/assets/filter-in.png" v-else>
				</div>
				<div class="filter" @click="selectFilter('out')" :class="{selected: filter === 'out'}">
					<img src="@/assets/filter-out-selected.png" v-if="filter === 'out'">
					<img src="@/assets/filter-out.png" v-else>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HomeView from '@/components/Home'
import uiCard from '@/components/uiCard'
import uiVote from '@/components/uiVote'
import { CARDS } from '@/config'

export default {
	components: {
		HomeView,
		uiCard,
		uiVote,
	},
	data() {
		return {
			cards: CARDS,
			footerHeight: '720px',
			filter: 'all',
			showFilter: false,
		}
	},
	mounted() {
		window.mainView = document.getElementById('view')
		window.addEventListener('resize', this.calcFooter)
		window.mainView.addEventListener('scroll', this.checkScroll)
		this.calcFooter()
		if (window.lastMainScroll) window.mainView.scrollTop = window.lastMainScroll
	},
	destroyed() {
		window.mainView.removeEventListener('scroll', this.checkScroll)
		window.removeEventListener('resize', this.calcFooter)
	},
	computed: {
		firstCards() {
			if (this.filter === 'in') return this.cards.filter(c => c.type === 'in')
			if (this.filter === 'out') return this.cards.filter(c => c.type === 'out')
			return this.cards.slice(0, 6)
		},
		secondCards() {
			if (this.filter !== 'all') return []
			return this.cards.slice(6)
		},
	},
	methods: {
		checkScroll() {
			window.lastMainScroll = window.mainView.scrollTop
			if (window.lastMainScroll > window.innerHeight - 2) this.showFilter = true
			else this.showFilter = false
		},
		calcFooter() {
			let width = window.innerWidth
			let res = Math.floor(width / 1.777)
			if (width < 736) res = 600
			this.footerHeight = res + 'px'
		},
		selectFilter(type) {
			ga('send', 'event', 'filter', type)
			this.filter = type
		},
	},
}
</script>


<style lang="less" scoped>
.main {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

header {
	max-width: 700px;
	margin-bottom: 50px;
	padding-top: 100px;

	.title {
		font-size: 56px;
		line-height: 60px;
		text-transform: uppercase;
		text-align: center;
	}

	.subline {
		margin-top: 30px;
		font-size: 18px;
	}
}

.cards {
	max-width: 780px;
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
	padding-top: 50px;
	padding-bottom: 50px;
}

footer {
	width: 100%;
	background-image: url('../assets/footer.png');
	background-size: cover;
	background-position: center bottom;
	display: flex;
	justify-content: center;
	align-items: center;

	.wrap {
		max-width: 600px;
		transform: translateY(-20%);
	}

	.title {
		font-size: 56px;
		text-transform: uppercase;
		line-height: 60px;
	}

	.text {
		font-size: 18px;
		margin-top: 30px;
	}

	.button {
		width: 260px;
		height: 60px;
		text-align: center;
		font-size: 22px;
		font-weight: bold;
		line-height: 60px;
		color: #007770;
		text-transform: uppercase;
		margin: 0 auto;
		margin-top: 60px;
		background: #fff;
		cursor: pointer;
		transition: all 200ms ease;
		text-decoration: none;
	}

	.button:hover {
		transform: scale(1.05);
	}
}

.filters-mobile {
	display: none;
}

.sideblock {
	position: fixed;
	left: 40px;
	top: 100px;
	opacity: 0;
	transition: opacity 300ms ease;
	pointer-events: none;

	&.visible {
		opacity: 1;
		pointer-events: all;
	}

	.back {
		text-decoration: none;
		margin-bottom: 30px;

		.title {
			font-size: 12px;
			opacity: 0.5;
			margin-top: 10px;
			color: #fff;
		}
	}

	.filter {
		width: 60px;
		height: 60px;
		font-weight: bold;
		letter-spacing: 3px;
		border: 1px dashed rgba(255, 255, 255, 0.7);
		border-bottom: none;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		opacity: 0.7;
		transition: all 200ms ease;
		cursor: pointer;

		img {
			width: 32px;
		}

		&:last-child {
			border: 1px dashed rgba(255, 255, 255, 0.7);
		}

		&:hover {
			opacity: 1;
		}

		&.selected {
			background: #fff;
			color: #007770;
			opacity: 1;
			cursor: default;
		}
	}
}

@media only screen and (max-device-width: 640px),
	only screen and (max-device-width: 736px),
	only screen and (max-width: 480px) {
	header {
		.title {
			font-size: 40px;
			line-height: 40px;
			text-transform: uppercase;
			text-align: center;
		}

		.subline {
			margin-top: 30px;
			font-size: 16px;
			padding: 0 20px;
		}
	}

	.cards {
		justify-content: space-around;
	}

	footer {
		width: 100%;
		margin-top: 300px;
		background-image: url('../assets/footer-mobile.png');
		background-size: cover;
		background-position: center bottom;
		display: flex;
		justify-content: center;
		align-items: center;

		.wrap {
			width: 90vw;
			max-width: 600px;
			transform: translateY(-480px);
		}

		.title {
			font-size: 24px;
			line-height: 24px;
		}

		.text {
			font-size: 14px;
			margin-top: 10px;
		}

		.button {
			margin-top: 30px;
		}
	}

	.sideblock {
		display: none;
	}

	.filters-mobile {
		display: flex;

		.filter {
			width: 60px;
			height: 60px;
			font-weight: bold;
			letter-spacing: 3px;
			border: 1px dashed rgba(255, 255, 255, 0.7);
			border-right: none;
			box-sizing: border-box;
			display: flex;
			justify-content: center;
			align-items: center;
			opacity: 0.7;
			transition: all 200ms ease;
			cursor: pointer;

			img {
				width: 32px;
			}

			&:last-child {
				border: 1px dashed rgba(255, 255, 255, 0.7);
			}

			&:hover {
				opacity: 1;
			}

			&.selected {
				background: #fff;
				color: #007770;
				opacity: 1;
				cursor: default;
			}
		}
	}
}
</style>